import React from 'react';
import { Icon, Row, Col } from 'antd';
import { withRouter } from 'react-router-dom';
import { Modal, CloseIcon } from './LoginStyles';
import Transition from 'react-transition-group/Transition';
import LoginForm from './LoginForm';
import RecoverForm from './RecoverForm';
import { Container } from '../../styles/BaseStyles';

class LoginModal extends React.Component {
  state = {
    login: true
  };

  toggleView = () => {
    const { login } = this.state;
    this.setState({ login: !login });
  };

  render() {
    const { show, onClose } = this.props;
    const { login } = this.state;
    return (
      <Transition
        timeout={{ enter: 0, exit: 200 }}
        in={show}
        unmountOnExit
        mountOnEnter
      >
        {state => (
          <Modal state={state}>
            <Container>
              <CloseIcon onClick={onClose}>
                <Icon type="close" theme="outlined" />
              </CloseIcon>
              <Row>
                <Col
                  xs={{ span: 24, offset: 0 }}
                  md={{ span: 18, offset: 3 }}
                  lg={{ span: 12, offset: 6 }}
                >
                  {login ? (
                    <LoginForm onClose={onClose} toggle={this.toggleView} />
                  ) : (
                    <RecoverForm onClose={onClose} toggle={this.toggleView} />
                  )}
                </Col>
              </Row>
            </Container>
          </Modal>
        )}
      </Transition>
    );
  }
}

export default withRouter(LoginModal);



// WEBPACK FOOTER //
// ./src/components/Login/LoginModal.js